type PhotoTipItemProps = {
  description: React.ReactNode;
  src: string;
};

export const PhotoTipItem = ({ description, src }: PhotoTipItemProps) => {
  return (
    <ul key={src} className="list-inline col-xs-12 col-md-9 tw-mb-0">
      <li className="v-center tw-min-w-[15%] tw-my-8 tw-mx-0">
        <img className="tw-min-w-[44px] tw-max-w-[60px]" alt="" src={src} />
      </li>
      <li className="v-center description">{description}</li>
    </ul>
  );
};
